import React from "react";
import localizationStrings from "../../../statics/localization";
import { toTrackId } from "../../../analytics/trackIds";

const SECTION_TYPES = {
  INTRO: 1,
  SUMMARY: 2,
  NEXT_EPISODE: 3
};

const getSectionLabel = (type) => {
  switch (type) {
    case SECTION_TYPES.INTRO:
      return localizationStrings.skipIntro;
    case SECTION_TYPES.SUMMARY:
      return localizationStrings.skipSummary;
    case SECTION_TYPES.NEXT_EPISODE:
      return localizationStrings.skipToNextEpisode;
    default:
      return "";
  }
};

const SectionSkipButton = ({ section, onSkip }) => {
  const handleClick = () => {
    if (onSkip) {
      onSkip(section);
    }
  };

  return (
    <button
      className="section-skip-button"
      data-track-id={toTrackId("player_skip", section.type)}
      onClick={handleClick}
    >
      {getSectionLabel(section.type)}
    </button>
  );
};

export { SECTION_TYPES };
export default SectionSkipButton;
